module.exports = __webpack_public_path__ + "img/model-faq-2.15f5cca2.png";